import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { HelmetProvider } from 'react-helmet-async';
import { FjdSpinner } from '@efast/fjd-react-components';
import './global.css';
import keycloak from './utils/keycloak';
import App from './App';
const container = document.getElementById('app');
const root = createRoot(container!);
root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{ checkLoginIframe: false }}
  >
    <React.StrictMode>
      <HelmetProvider>
        <Suspense fallback={<FjdSpinner size="s" />}>
          <App />
        </Suspense>
      </HelmetProvider>
    </React.StrictMode>
  </ReactKeycloakProvider>
);
